import CollapsedCard from './CollpasedCard';
import CardBack from './CardBack';
const CardConverter = require('@tta/engine/Utilities/Converters/CardConverter');

// A card named in text (see CardRefs in the engine): "c" a card everyone can see, as in hand (hover for the card);
// "b" one face down, its back with its age
function CardToken({kind, body})
{
    if (kind === 'b')
    {
        return <span className="tta-card-token"><CardBack age={body}/></span>;
    }
    // (version: a card the expansion changed, in the game's version)
    const [type, name, age, version] = body.split('|');
    return <span className="tta-card-token"><CollapsedCard card={CardConverter({ type, name, age, ...(version ? { version } : {}) })}/></span>;
}

export default CardToken;
